module.exports = __webpack_public_path__ + "amazon-author-logo.png";